import React from 'react';
import { Spinner } from 'flowbite-react';
import JsonView from '@uiw/react-json-view';

interface IDeviceIpInfo {
  deviceInfo: any;
  loading: boolean;
}

export const DeviceIpInfo: React.FC<IDeviceIpInfo> = ({
  deviceInfo,
  loading,
}) => {
  return (
    <>
      {loading ? (
        <div className="text-center">
          <Spinner />
        </div>
      ) : (
        <JsonView
          value={deviceInfo?.ipInfo || {}}
          displayObjectSize={false}
          displayDataTypes={false}
          enableClipboard={false}
        />
      )}
    </>
  );
};
